import { Model } from "src/app/lib/ngx-crud.service";

export class Marker extends Model {

  marker_NAME!: string;
  marker_TYPES!: string;
  marker_SUBTYPES!: string;
  marker_COORDINATES: any;
  marker_METADATA: any

  constructor(record?: any) {
    super(record);
    record = record || {};
    Object.assign(this, record);
  }
}
